import ArticleController from "../../controller/article/ArticleController"
import KpiIndicatorController from "../../controller/kpi/KpiIndicatorController"
import KpiScoreController from "../../controller/kpi/KpiScoreController"
import KpiVariableController from "../../controller/kpi/KpiVariableController"
import NoteController from "../../controller/note/NoteController"
import RkapController from "../../controller/rkap/RkapController"
import UserController from "../../controller/user/UserController"

const _dewas = [
    // kpi indicator
    { path: 'kpi/indicator/data', element: KpiIndicatorController, view: 'data' },

    // kpi variable
    { path: 'kpi/variable/data', element: KpiVariableController, view: 'data' },

    // kpi score
    { path: 'kpi/score/data', element: KpiScoreController, view: 'data' },

    // users
    { path: 'user/form', element: UserController, view: 'form' },
    { path: 'user/data', element: UserController, view: 'data' },
    { path: 'user/data/:code', element: UserController, view: 'detail' },

    // rkap
    { path: 'rkap/data', element: RkapController, view: 'data' },

    // notes
    { path: 'note/form', element: NoteController, view: 'form' },
    { path: 'note/data', element: NoteController, view: 'data' },
    { path: 'note/data/:code', element: NoteController, view: 'detail' },

    // article note
    { path: 'article', element: ArticleController, view: 'article' },
    { path: 'article/:code', element: ArticleController, view: 'detail' },
]

export default _dewas